// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","fontNormal":"_2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","grid":"_1HHfP6N_S1JrFFdsKICvIR","emptyState":"_2XipA1HLwroiT5i5lhUJCy _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","fade-in-out":"xVCtjessZOJQhskjpINoI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/homePage/homePage.css
// module id = 937
// module chunks = 0